import { render, staticRenderFns } from "./TestReportContent.vue?vue&type=template&id=0a5d623a&"
import script from "./TestReportContent.vue?vue&type=script&lang=ts&"
export * from "./TestReportContent.vue?vue&type=script&lang=ts&"
import style0 from "./TestReportContent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports